import { IAdapter, Adapter } from '@tencent/workbench';
export const SLIDE_ADAPTER = 'slideAdapter';

// eslint-disable-next-line new-cap
@Adapter(SLIDE_ADAPTER)
export class SlideAdapter implements IAdapter<any> {
    public attachEditor() {
    }

    public setValue() {
        // do nothing
    }

    public requestFocus() {
        // do nothing
    }

    public requestBlur() {
        // do nothing
    }

    public isCaret() {
        // do nothing
        return false;
    }

    public destroy() {
        // do nothing
    }
}
